import { Drawer } from '../../ui';
import { CampaignWizard } from './CampaignWizard';

interface CampaignWizardDrawerProps {
  open: boolean;
  editId: number | null;
  onClose: () => void;
  onCompleted?: () => void;
}

export function CampaignWizardDrawer({
  open,
  editId,
  onClose,
  onCompleted,
}: CampaignWizardDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={editId ? 'Editar campanha' : 'Nova campanha'}
      width={720}
    >
      <CampaignWizard editId={editId} onClose={onClose} onCompleted={onCompleted} />
    </Drawer>
  );
}

export default CampaignWizardDrawer;
